import { inject, Injectable } from '@angular/core'

import { BrowserLocalStorage } from '@ti/core/common/storage/local.storage'

const PROMPTED_AT_KEY = 'app.update-prompted-at'

/** Allows one service-worker update suggestion per local calendar day, shared by all tabs. */
@Injectable({ providedIn: 'root' })
export class AppUpdatePromptPolicy {
  protected readonly storage = inject(BrowserLocalStorage)

  public canPrompt(now = new Date()): boolean {
    // A missing or malformed value yields "Invalid Date", which never matches today.
    const promptedAt = new Date(this.storage.getItem(PROMPTED_AT_KEY) ?? NaN)
    return promptedAt.toDateString() !== now.toDateString()
  }

  public markPrompted(now = new Date()) {
    try {
      this.storage.setItem(PROMPTED_AT_KEY, now.toISOString())
    } catch (e) {
      console.warn('Cannot record the update suggestion', e)
    }
  }
}
